// src/api/profile.js
const RAW_BASE = process.env.REACT_APP_API_BASE || "/server/exodia_uno_project_function";
const BASE = RAW_BASE.replace(/\/+$/, "");

async function toJSON(res) {
  const t = await res.text();
  try { return t ? JSON.parse(t) : null; } catch { return t; }
}

const parseMaybe = (s, fallback = {}) => {
  if (s == null || s === "") return fallback;
  if (typeof s !== "string") return s;
  try { return JSON.parse(s); } catch { return fallback; }
};

export const ProfileAPI = {
  async get(talentId) {
    const res = await fetch(`${BASE}/profile?talentId=${encodeURIComponent(talentId)}`);
    const data = await toJSON(res);
    if (!res.ok) throw new Error(data?.error?.message || data?.error || res.statusText);
    const row = data?.row || {};
    return {
      talentId: row.talentId,
      clientMsg: row.clientMsg || "",
      availMap: parseMaybe(row.availMap, {}),
      behavioralStatuses: parseMaybe(row.behavioralStatuses, {}),
      skillsStatuses: parseMaybe(row.skillsStatuses, {}),
      starStatuses: parseMaybe(row.starStatuses, {}),
      secondStatuses: parseMaybe(row.secondStatuses, {}),
      ROWID: row.ROWID,
    };
  },

  async save(payload) {
    const res = await fetch(`${BASE}/profile`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    const data = await toJSON(res);
    if (!res.ok) throw new Error(data?.error?.message || data?.error || res.statusText);
    return data?.row || {};
  },
};
